import { YesOrNo } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Boolean";
import { ProductDetail } from "Components/InsuranceDetailsCard/ProductDetailsTable/interface";
import { TextManager } from "Components/TextContext";
import { HouseContentsProduct } from "Store/interfaces/products/checkout/riskProducts/houseProducts/HouseContentsProduct";
import { isDefined } from "Utils/functions";
import React from "react";

export const houseContentsDetailsList = (
  product: HouseContentsProduct,
): ProductDetail[] => {
  const { getText } = TextManager;

  return [
    {
      name: "fullRental",
      value: <YesOrNo value={product.fullRental} />,
    },
    {
      name: "fireResistantBuildingMaterial",
      value: <YesOrNo value={product.fireResistantBuildingMaterial} />,
    },
    {
      name: getText("houseform.shorttitle.hasfirealarm"),
      hidden:
        !isDefined(product.fireAlarmCode) && !isDefined(product.hasFireAlarm),
      value: (
        <YesOrNo
          value={product.fireAlarmCode ?? product.hasFireAlarm ?? false}
        />
      ),
    },
    {
      name: getText("houseform.shorttitle.hasburglaralarm"),
      value: (
        <YesOrNo
          value={
            product.antiTheftProtection ?? product.hasBurglarAlarm ?? false
          }
        />
      ),
    },
    {
      name: "damageRecentYears",
      value: product.damageCountRecentYears ?? 0,
    },
    {
      name: "yearOfLastDamage",
      value: product.yearOfLastDamage,
      hidden: product.damageCountRecentYears === 0,
    },
  ];
};
